import { render, staticRenderFns } from "./CustomerGreenPart.vue?vue&type=template&id=3c834ffe"
import script from "./CustomerGreenPart.vue?vue&type=script&lang=ts"
export * from "./CustomerGreenPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports